<div class="betslip-mobile-dialog">
  <app-betslip
    [expanded]="true"
    [pulseMaxWin]="true"
    [mobileDeleteConfirm]="true"
    [showBackButton]="true"
    [groups]="sportsbook.betSlipGroups()"
    [summary]="sportsbook.betSlipSummary()"
    [submissionState]="sportsbook.betSlipSubmissionState()"
    [maxWinPulseKey]="sportsbook.maxWinPulseKey()"
    (toggleExpanded)="close()"
    (selectionToggle)="sportsbook.toggleSelection($event)"
    (stakeChange)="sportsbook.updateStake($event)"
    (modeChange)="sportsbook.setBetSlipMode($event)"
    (systemStep)="sportsbook.stepBetSlipSystemX($event)"
    (clearBetSlip)="sportsbook.clearBetSlip()"
    (placeBet)="sportsbook.placeBet()"
  ></app-betslip>
</div>
